module.exports = __webpack_public_path__ + "tw.svg?c4c781947d073eb65233abb4788791d2";